// Newsletter API helpers (Phase 19.1).
function backendBase() {
  return process.env.REACT_APP_BACKEND_URL || '';
}
function authHeader() {
  const token = localStorage.getItem('healthcues_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}
async function jsonOrThrow(res) {
  let body = null;
  try { body = await res.json(); } catch (_) {}
  if (!res.ok) {
    const detail = body && body.detail;
    if (detail && typeof detail === 'object') {
      const err = new Error(detail.message || 'Request failed');
      err.providerError = detail.providerError;
      err.status = res.status;
      throw err;
    }
    const err = new Error((body && body.detail) || `Request failed (${res.status})`);
    err.status = res.status;
    throw err;
  }
  return body;
}

export async function listNewsletters() {
  const res = await fetch(`${backendBase()}/api/newsletters`, { headers: { ...authHeader() } });
  return jsonOrThrow(res);
}
export async function getNewsletter(id) {
  const res = await fetch(`${backendBase()}/api/newsletters/${encodeURIComponent(id)}`, { headers: { ...authHeader() } });
  return jsonOrThrow(res);
}
export async function createNewsletter(payload) {
  const res = await fetch(`${backendBase()}/api/newsletters`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(payload),
  });
  return jsonOrThrow(res);
}
export async function updateNewsletter(id, payload) {
  const res = await fetch(`${backendBase()}/api/newsletters/${encodeURIComponent(id)}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...authHeader() },
    body: JSON.stringify(payload),
  });
  return jsonOrThrow(res);
}
export async function deleteNewsletter(id) {
  const res = await fetch(`${backendBase()}/api/newsletters/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: { ...authHeader() },
  });
  return jsonOrThrow(res);
}
export async function previewNewsletter(id) {
  const res = await fetch(`${backendBase()}/api/newsletters/${encodeURIComponent(id)}/preview`, { headers: { ...authHeader() } });
  return jsonOrThrow(res);
}
export async function testSendNewsletter(id) {
  const res = await fetch(`${backendBase()}/api/newsletters/${encodeURIComponent(id)}/test-send`, {
    method: 'POST',
    headers: { ...authHeader() },
  });
  return jsonOrThrow(res);
}
export async function sendNewsletter(id) {
  const res = await fetch(`${backendBase()}/api/newsletters/${encodeURIComponent(id)}/send`, {
    method: 'POST',
    headers: { ...authHeader() },
  });
  return jsonOrThrow(res);
}
export async function getAudienceCount() {
  const res = await fetch(`${backendBase()}/api/newsletters/audience/count`, { headers: { ...authHeader() } });
  return jsonOrThrow(res);
}
